import { classNames } from "shared/lib/classNames/classNames";
import cls from "./Paragraph.module.scss";
import {HTMLAttributes} from "react";

export enum ParagraphTheme {
    ALIGN_LEFT = "left",
    ALIGN_RIGHT = "right",
    NEUTRAL = "neutral",
    BRIGHT = "bright"
}

export interface ParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
    className?: string;
    theme?: ParagraphTheme;
    ul?: string[];
}

const Paragraph = ({ className, theme, children, ul, ...rest }: ParagraphProps) => {
    return (
        <p {...rest} className={classNames(cls.Paragraph, {}, [className, theme ? cls[theme] : undefined])}>
            {children}
            {ul && (
                <ul className={cls.Paragraph__list}>
                    {ul.map((li) => <li key={li.slice(0, 5)}>{li}</li>)}
                </ul>
            )}
        </p>
    )
};

export default Paragraph;



